export default "__VITE_ASSET__ZpSoCoFo__"